export enum CRUDType {
  Create = 'create',
  Update = 'update',
  Delete = 'delete',
  Read = 'read'
}
